import React from 'react';
import { useNavigate } from 'react-router-dom';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const HeroSection = ({ course, progress }) => {
  const navigate = useNavigate();

  const featuredCourse = {
    id: 1,
    title: course?.title || "Formação de Líderes e Mentores",
    description: course?.summary || "Continue sua jornada de aprendizagem.",
    thumbnail: course?.cover || "/assets/images/diane-splash.png",
    progress: progress?.progressPercentage ?? 0,
    instructor: course?.instructor || "Diane Andrade",
    isNew: false,
    category: course?.category || "Liderança"
  };

  const handleStartCourse = () => {
    navigate('/course/formacao-lideres-mentores/module/modulo-1-formacao-de-lideres-e-mentores');
  };

  const handleContinueLearning = () => {
    // Navegar para o módulo em vez de uma lesson específica
    navigate('/course/formacao-lideres-mentores/module/modulo-1-formacao-de-lideres-e-mentores');
  };

  return (
    <section className="relative h-[500px] md:h-[600px] overflow-hidden rounded-lg mb-8">
      {/* Background Image */}
      <div className="absolute inset-0">
        <Image
          src={featuredCourse?.thumbnail}
          alt={featuredCourse?.title}
          className="w-full h-full object-cover"
        />
        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/50 to-transparent"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
      </div>
      {/* Content */}
      <div className="relative z-10 h-full flex items-center">
        <div className="container mx-auto px-6">
          <div className="max-w-2xl">
            {/* Category Badge */}
            <div className="flex items-center space-x-2 mb-4">
              {featuredCourse?.isNew && (
                <span className="px-3 py-1 bg-secondary text-secondary-foreground text-sm font-medium rounded-full">
                  Novo
                </span>
              )}
              <span className="px-3 py-1 bg-accent/20 text-white text-sm font-medium rounded-full backdrop-blur-sm">
                {featuredCourse?.category}
              </span>
            </div>

            {/* Title */}
            <h1 className="text-3xl md:text-5xl font-heading font-bold text-white mb-4 leading-tight">
              {featuredCourse?.title}
            </h1>

            {/* Description */}
            <p className="text-lg text-white/90 mb-6 leading-relaxed max-w-xl">
              {featuredCourse?.description?.split('\n')?.[0]}
            </p>

            {/* Course Info */}
            <div className="flex items-center space-x-6 mb-8 text-white/80">
              <div className="flex items-center space-x-2">
                <Icon name="User" size={16} />
                <span className="text-sm font-caption">{featuredCourse?.instructor}</span>
              </div>
              {featuredCourse?.progress > 0 && (
                <div className="flex items-center space-x-2">
                  <Icon name="Play" size={16} />
                  <span className="text-sm font-caption">{featuredCourse?.progress}% concluído</span>
                </div>
              )}
            </div>

            {/* Progress Bar */}
            {featuredCourse?.progress > 0 && (
              <div className="mb-8">
                <div className="w-full bg-white/20 rounded-full h-2 backdrop-blur-sm">
                  <div 
                    className="bg-secondary h-2 rounded-full transition-all duration-500"
                    style={{ width: `${featuredCourse?.progress}%` }}
                  ></div>
                </div>
              </div>
            )}

            {/* Action Buttons */}
            <div className="flex flex-col sm:flex-row space-y-3 sm:space-y-0 sm:space-x-4">
              {featuredCourse?.progress > 0 ? (
                <Button
                  variant="default"
                  size="lg"
                  onClick={handleContinueLearning}
                  iconName="Play"
                  iconPosition="left"
                  className="bg-secondary text-secondary-foreground hover:bg-secondary/90"
                >
                  Continuar Assistindo
                </Button>
              ) : (
                <Button
                  variant="default"
                  size="lg"
                  onClick={handleStartCourse}
                  iconName="Play"
                  iconPosition="left"
                  className="bg-secondary text-secondary-foreground hover:bg-secondary/90"
                >
                  Começar Curso
                </Button>
              )}
              
              <Button
                variant="outline"
                size="lg"
                onClick={() => navigate('/courses')}
                iconName="Info"
                iconPosition="left"
                className="border-white/30 text-white hover:bg-white/10 backdrop-blur-sm"
              >
                Mais Informações
              </Button>
            </div>
          </div>
        </div>
      </div>
      {/* Floating Elements */}
      <div className="absolute bottom-6 right-6 hidden md:flex items-center space-x-2 text-white/60">
        <Icon name="Volume2" size={20} />
        <Icon name="Settings" size={20} />
      </div>
    </section>
  );
};

export default HeroSection;
